<template>
    <div>
        <h1 class="display-heading">Company Settings</h1>

        <div class="card">
            <div class="card-header">Company Credit</div>
            <div class="card-body">
                <form data-vv-scope="company-credit" @submit.prevent="validateCompanyCreditForm">
                    <table class="table table-borderless table-settings">
                        <colgroup>
                            <col width="40">
                            <col>
                        </colgroup>
                        <tbody>
                            <tr>
                                <td scope="row">1.</td>
                                <td>
                                    Starting date of 12-month cycle
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <div>
                                        <input type="text" name="annualResetDate" data-vv-as="usage zerorize date"
                                            data-vv-validate-on="blur" v-model="creditBalance.annualResetDate"
                                            v-mask="'##/##/####'" v-validate="'required|date_format:DD/MM/YYYY'"
                                            placeholder="DD/MM/YYYY" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('company-credit.annualResetDate')
                                    }" />
                                        <div v-show="validationErrors.has('company-credit.annualResetDate')"
                                            class="invalid-feedback">
                                            {{ validationErrors.first('company-credit.annualResetDate') }}
                                        </div>
                                    </div>
                                    <div>
                                        <small>
                                            The remaining balance of annual limit of all employees will be restored back to initial annual limit automatically 12 months after this selected date.
                                        </small>
                                    </div>
                                    <div>
                                        <small>
                                            Automatically zerorize outpatient treatment expenses on selected date (new staff: example: start date : 4/1/2019. Initial annual limit: RM1,000; Annual limit balance dated 31/05/2019: RM800, initial annual limit restores to RM1,000, if 01/06/2019 is selected as the date of restoring annual limit across company)
                                        </small>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td>Participants who join after the start date of item 1, their balance of annual limit
                                    will be restored to initial annual limit automatically, together with other
                                    participants in item 1 on day 366, after start date of item 1.</td>
                            </tr>
                            <tr>
                                <td>3.</td>
                                <td>Employee annual usage limit (RM)</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <div>
                                        <input type="text" name="usageLimit" data-vv-validate-on="blur"
                                            data-vv-as="employee annual usage limit"
                                            v-validate="'required|decimal:2|min_value:0.01'"
                                            v-model="creditBalance.annualLimit" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('company-credit.usageLimit')
                                    }" />
                                        <div v-show="validationErrors.has('company-credit.usageLimit')"
                                            class="invalid-feedback">
                                            {{ validationErrors.first('company-credit.usageLimit') }}
                                        </div>
                                    </div>
                                    <small>The maximum usage of credit amount allowed for each employee.</small>
                                </td>
                            </tr>
                            <tr>
                                <td>4.</td>
                                <td>
                                    <div class="form-check">
                                        <label class="form-check-label d-flex align-items-center">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="creditBalance.hasConsultationTransactionLimit">
                                            <span>Set transaction limit for tele-consultation payment</span>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <div>
                                        <input type="text" name="consultationTransactionLimit" data-vv-validate-on="blur"
                                            data-vv-as="consultation transaction limit"
                                            v-validate="creditBalance.hasConsultationTransactionLimit ? 'required|decimal:2|min_value:0.00': ''"
                                            v-model="creditBalance.consultationTransactionLimit"
                                            :disabled="!creditBalance.hasConsultationTransactionLimit"
                                            :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('company-credit.consultationTransactionLimit')
                                    }" />
                                        <div v-show="validationErrors.has('company-credit.consultationTransactionLimit')"
                                            class="invalid-feedback">
                                            {{ validationErrors.first('company-credit.consultationTransactionLimit') }}
                                        </div>
                                    </div>
                                    <small>The maximum allowed price to be paid for each transaction. Employee shall make payment manually for transaction amount exceeding the limit set.<br>You may set to 0 if not applicable.</small>
                                </td>
                            </tr>
                            <tr>
                                <td>5.</td>
                                <td>
                                    <div class="form-check">
                                        <label class="form-check-label d-flex align-items-center">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="creditBalance.hasPrescriptionTransactionLimit">
                                            <span>Set transaction limit for medicine payment (tele-consultation)</span>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <div>
                                        <input type="text" name="prescriptionTransactionLimit" data-vv-validate-on="blur"
                                            data-vv-as="prescription transaction limit"
                                            v-validate="creditBalance.hasPrescriptionTransactionLimit ? 'required|decimal:2|min_value:0.00': ''"
                                            v-model="creditBalance.prescriptionTransactionLimit"
                                            :disabled="!creditBalance.hasPrescriptionTransactionLimit"
                                            :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('company-credit.prescriptionTransactionLimit')
                                    }" />
                                        <div v-show="validationErrors.has('company-credit.prescriptionTransactionLimit')"
                                            class="invalid-feedback">
                                            {{ validationErrors.first('company-credit.prescriptionTransactionLimit') }}
                                        </div>
                                    </div>
                                    <small>The maximum allowed price to be paid for each transaction. Employee shall make payment manually for transaction amount exceeding the limit set.<br>You may set to 0 if not applicable.</small>
                                </td>
                            </tr>
                            <tr>
                                <td>6.</td>
                                <td>
                                    <div class="form-check">
                                        <label class="form-check-label d-flex align-items-center">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="creditBalance.hasClinicConsultationTransactionLimit">
                                            <span>Set combined limit for clinic consultations and clinic medicine.</span>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <div>
                                        <input type="text" name="clinicConsultationTransactionLimit" data-vv-validate-on="blur"
                                            data-vv-as="clinic consultation transaction limit"
                                            v-validate="creditBalance.hasClinicConsultationTransactionLimit ? 'required|decimal:2|min_value:0.00': ''"
                                            v-model="creditBalance.clinicConsultationTransactionLimit"
                                            :disabled="!creditBalance.hasClinicConsultationTransactionLimit"
                                            :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('company-credit.clinicConsultationTransactionLimit')
                                    }" />
                                        <div v-show="validationErrors.has('company-credit.clinicConsultationTransactionLimit')"
                                            class="invalid-feedback">
                                            {{ validationErrors.first('company-credit.clinicConsultationTransactionLimit') }}
                                        </div>
                                    </div>
                                    <small>The maximum allowed price to be paid for each transaction of clinic consultations and clinic medicine. Employee shall make payment manually for transaction amount exceeding the limit set.<br>You may set to 0 if not applicable.</small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
            <div class="card-footer">
                <button class="btn btn-primary btn-primary-insv mr-2" @click="saveCompanyCreditSettings">Save
                    Changes</button>
                <button class="btn btn-secondary" @click="getCompanyCreditSettings">Cancel</button>
            </div>
        </div>

        <popup-modal ref="popupModalUpdateSuccess" :hasCloseButton="false" title="Success!">
            <template slot="content">
                <p>Settings updated successfully!</p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv"
                    @click="dismissSuccessModal">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
import {
    mask
} from 'vue-the-mask';
import toggleButton from '@/components/toggle-button';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'CompanySettings',
    'directives': {
        mask
    },
    'components': {
        toggleButton,
        popupModal
    },
    mounted () {
        this.getCompanyCreditSettings();
    },
    data () {
        return {
            'creditBalance': {
                'annualResetDate': null,
                'annualLimit': 0,
                'hasConsultationTransactionLimit': false,
                'consultationTransactionLimit': 0,
                'hasPrescriptionTransactionLimit': false,
                'prescriptionTransactionLimit': 0,
                'hasClinicConsultationTransactionLimit': false,
                'clinicConsultationTransactionLimit': 0
            }
        };
    },
    'methods': {
        validateCompanyCreditForm () {
            return this.$validator.validateAll('company-credit');
        },
        getCompanyCreditSettings () {
            this.axios.get('SystemSetting/GetCompanySettings').then(({
                data
            }) => {
                if (data.data) {
                    let creditBalanceSettings = data.data.cb;

                    this.creditBalance.annualResetDate = convertDateToDDMMYYYY(creditBalanceSettings.alrd);
                    this.creditBalance.annualLimit = creditBalanceSettings.eal;
                    this.creditBalance.hasConsultationTransactionLimit = creditBalanceSettings.hctl;
                    this.creditBalance.consultationTransactionLimit = creditBalanceSettings.ectl;
                    this.creditBalance.hasPrescriptionTransactionLimit = creditBalanceSettings.hptl;
                    this.creditBalance.prescriptionTransactionLimit = creditBalanceSettings.eptl;
                    this.creditBalance.hasClinicConsultationTransactionLimit = creditBalanceSettings.hcctl;
                    this.creditBalance.clinicConsultationTransactionLimit = creditBalanceSettings.ecctl;
                }
            });
        },
        saveCompanyCreditSettings () {
            this.validateCompanyCreditForm().then((isValid) => {
                if (isValid) {
                    this.axios.post('SystemSetting/UpdateCompanyCreditSettings', {
                        'alrd': convertDateToIso8601(this.creditBalance.annualResetDate),
                        'eal': this.creditBalance.annualLimit,
                        'hctl': this.creditBalance.hasConsultationTransactionLimit,
                        'ectl': this.creditBalance.consultationTransactionLimit,
                        'hptl': this.creditBalance.hasPrescriptionTransactionLimit,
                        'eptl': this.creditBalance.prescriptionTransactionLimit,
                        'hcctl': this.creditBalance.hasClinicConsultationTransactionLimit,
                        'ecctl': this.creditBalance.clinicConsultationTransactionLimit
                    }).then(({
                        data
                    }) => {
                        this.$refs.popupModalUpdateSuccess.show();
                    });
                }
            });
        },
        dismissSuccessModal () {
            this.$refs.popupModalUpdateSuccess.hide();
        }
    }
};

</script>

<style>
    .table-settings.table th,
    .table-settings.table td {
        vertical-align: initial;
    }

</style>
